import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Icon, Input } from "antd";

import { GlobalContext } from "../../../../app/providers/GlobalState";
import { useAxios } from "../../../../shared/hooks/useAxios";
import { useNotification } from "../../../../shared/hooks/useNotification";
import { logo_simples } from "../../../../assets/logos";
import { obterUrlEntidade } from "../urlEntidade";
import styles from "../Navbar.module.scss";

const { Search } = Input;

const PesquisaCanais = () => {
    const [entidades, setEntidades] = useState([]);

    const context = useContext(GlobalContext);
    const { fetchData } = useAxios();
    const notify = useNotification();

    const fecharPesquisa = () => context.atualizarState({ search_entidade: false });

    useEffect(() => {
        fecharPesquisa();
    }, []);

    const pesquisarEntidades = async pesquisa => {
        const { data, error } = await fetchData({
            method: "get",
            url: "/api/pagina-entidade/pesquisar-entidade",
            params: { pesquisa }
        });

        if (!error) setEntidades(data);
        else notify.error("Erro", "Não foi possível procurar canal!");
    };

    const onKeyDown = event => {
        if (event.keyCode === 27) fecharPesquisa();
    };

    if (!context.search_entidade) return null;

    return (
        <div className={styles.searchFullscreen} onKeyDown={onKeyDown}>
            <div className="container">
                <Icon type="close" className={styles.closeSearch} onClick={fecharPesquisa} />
                <Search placeholder="Procurar Canal" name="inputPesquisa" autoComplete="off" onSearch={pesquisarEntidades} />
                <div className={styles.listagemEntidades}>
                    {entidades.map(entidade => {
                        const href = obterUrlEntidade(entidade);
                        const conteudo = (
                            <>
                                <div className={styles.containerImg}>
                                    <img src={entidade.logo ? entidade.logo : logo_simples} alt={entidade.nome} />
                                </div>
                                <span className={styles.nome}>{entidade.nome}</span>
                            </>
                        );

                        return entidade.dominio ? (
                            <a key={entidade.id} href={href} target="_blank" rel="noopener noreferrer" className={styles.entidade}>
                                {conteudo}
                            </a>
                        ) : (
                            <Link key={entidade.id} to={href} className={styles.entidade}>
                                {conteudo}
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default PesquisaCanais;
